module.exports = "<div class=\"fury-page-load-animation\"></div>\r\n<router-outlet></router-outlet>\r\n"